// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__3BVw7","typo":"select_typo__FbC6D"};